@use '@/scss/underscore' as _;

.copyToClipboard {
  display: block;
}

.oidcConfigPreview {
  margin-top: _.unit(3);
}
